import {Component} from "@angular/core";

@Component({
    selector: "fui-stacked-field",
    styleUrls: ["./stacked-field.component.scss"],
    templateUrl: "./stacked-field.component.html"
})
export class FUIFormStackedFieldComponent {

}
